import SvgLabelPrinting from '../../../components/icons/SvgLabelPrinting';
import {
  SvgNotification,
  SvgSignature,
  SvgDeliveryGuarantee,
  SvgProtectionAdd,
  SvgProtection,
  SvgPrintInStore,
  SvgGlobe,
  SvgEmail,
  SvgCalendarOneDay
} from '@parcel2go/core-ui';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';

export const ExtendedBaseCoverExtra = 'ExtendedBaseCover';
export const CoverExtra = 'Cover';
export const SignatureExtra = 'Signature';
export const PrintInStoreExtra = 'PrintInStore';
export const SmsExtra = 'Sms';
export const SameDayCollectionExtra = 'SameDayCollection';
export const DeliveredDutyPaidExtra = 'DeliveredDutyPaid';
export const DeliveryGuaranteeExtra = 'DeliveryGuarantee';
export const DriverBringsLabelExtra = 'DriverBringsLabel';
export const ThirdPartyEmail = 'ThirdPartyEmail';
export const Oversize = 'Oversize';

export const ProtectionExtraIds = [ExtendedBaseCoverExtra, CoverExtra];
export const ExtrasWithCustomUi = [ExtendedBaseCoverExtra, CoverExtra, DeliveredDutyPaidExtra, SameDayCollectionExtra];

export function ExtrasIcon(props: { Id: string }) {
  switch (props.Id) {
    case SmsExtra:
      return <SvgNotification />;
    case SameDayCollectionExtra:
      return <SvgCalendarOneDay />;
    case SignatureExtra:
      return <SvgSignature />;
    case DeliveryGuaranteeExtra:
      return <SvgDeliveryGuarantee />;
    case DriverBringsLabelExtra:
      return <SvgLabelPrinting />;
    case CoverExtra:
      return <SvgProtectionAdd />;
    case ExtendedBaseCoverExtra:
      return <SvgProtection />;
    case PrintInStoreExtra:
      return <SvgPrintInStore />;
    case DeliveredDutyPaidExtra:
      return <SvgGlobe />;
    case ThirdPartyEmail:
      return <SvgEmail />;
  }
  return null;
}

export function ExtrasIconSrc(props: { Id: string }) {
  switch (props.Id) {
    case SmsExtra:
      return `/theme/icons/Notification.svg`;
    case SignatureExtra:
      return `/theme/icons/Signature.svg`;
    case DeliveryGuaranteeExtra:
      return `/theme/icons/DeliveryGuarantee.svg`;
    case DriverBringsLabelExtra:
      return `/theme/icons/LabelPrinting.svg`;
    case CoverExtra:
      return `/theme/icons/ProtectionAdd.svg`;
    case ExtendedBaseCoverExtra:
      return `/theme/icons/Protection.svg`;
    case PrintInStoreExtra:
      return `/theme/icons/PrintInStore.svg`;
    case DeliveredDutyPaidExtra:
      return `/theme/icons/Customs.svg`;
    case ThirdPartyEmail:
      return `/theme/icons/Email.svg`;
  }
  return null;
}

export function ExtrasTitle(props: { Id: string; Name: string }) {
  switch (props.Id) {
    case ExtendedBaseCoverExtra:
      return `Basic\nProtection`;
    case CoverExtra:
      return `Full\nProtection`;
    case SignatureExtra:
      return `Proof of\nDelivery`;
    case SmsExtra:
      return `Delivery\nConfirmation`;
    case PrintInStoreExtra:
      return `Print In\nStore`;
    case DeliveredDutyPaidExtra:
      return `Delivered\nDuty Paid`;
    case DeliveryGuaranteeExtra:
      return `Delivery\nGuarantee`;
    case DriverBringsLabelExtra:
      return `Driver\nBrings Label`;
    case ThirdPartyEmail:
      return `Delivery\nEmail`;
    default:
      return props.Name || props.Id;
  }
}
export function ExtrasDescription(props: { Id: string; Name: string }) {
  switch (props.Id) {
    case ExtendedBaseCoverExtra:
      return `Protect your parcel with ${toDisplayCurrency(null, 20)} protection.`;
    case CoverExtra:
      return 'Fully Protect your parcel (service limits apply).';
    case SignatureExtra:
      return 'Add a signature to guarantee your parcel has been received.';
    case SmsExtra:
      return 'Receive text message updates.';
    case SameDayCollectionExtra:
      return 'Same day collection.';
    case PrintInStoreExtra:
      return 'No printer, no problem, take your email confirmation with QR code, to your nearest print in store shop.';
    case DeliveryGuaranteeExtra:
      return "Receive a refund of the carriage if your parcel doesn't arrive on-time.";
    case DriverBringsLabelExtra:
      return 'Have the driver bring your label(s) on collection.';
    case DeliveredDutyPaidExtra:
      return 'Would you like to pay for any tax and import duties before you send your parcel?';
    case ThirdPartyEmail:
      return 'Would you like the recipient to receive a delivery Email from the courier?';
    default:
      return null;
  }
}
